import {Editor} from '@tiptap/react';
import React, {FC} from 'react';
import styled from 'styled-components';

import {useToggle} from '../../../../../shared/helpers/src/react/hooks/hookHelpers';
import {FontColorDropdown} from './tools/fontColorDropdown';
import {HeadingDropdown} from './tools/headingDropdown';
import {HighlightDropdown} from './tools/highlightDropdown';
import {ImageButton} from './tools/imageButton';
import {LinkButton} from './tools/linkButton';
import {ListButton} from './tools/listButton';
import {SimpleButton, SimpleButtonsEnum} from './tools/simpleButton';
import {ToggleFormattingButton} from './tools/toggleFormattingButton';

/*
 * Props.
 */

interface ToolbarProps {
  editor: Editor;
}

/*
 * Style.
 */

const StyledBorderDiv = styled.div`
  border-top: 1px solid ${(p) => p.theme.message.border};
`;

const StyledWrapperDiv = styled.div`
  display: flex;
  flex-direction: column;
  box-shadow: 0px 5px 10px ${(p) => p.theme.greys.shade30};
  border: 1px solid ${(p) => p.theme.greys.shade30};
  border-bottom: 0px;
  width: inherit;
`;

const StyledFirstRowDiv = styled.div`
  display: flex;
  margin: 0px 10px;
  gap: 4px;
  align-items: center;
`;

const StyledSecondRowDiv = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
  margin: 10px;
`;

const StyledDropdownDiv = styled.div`
  margin-right: 4px;
`;

/*
 * Component.
 */

export const Toolbar: FC<ToolbarProps> = ({editor}) => {
  const [isTopRowVisible, toggleTopRowVisibility] = useToggle(true);
  return (
    <StyledWrapperDiv>
      {isTopRowVisible && (
        <>
          <StyledFirstRowDiv>
            <StyledDropdownDiv>
              <HeadingDropdown editor={editor} />
            </StyledDropdownDiv>
            <StyledDropdownDiv>
              <FontColorDropdown editor={editor} />
            </StyledDropdownDiv>
            <StyledDropdownDiv>
              <HighlightDropdown editor={editor} />
            </StyledDropdownDiv>
            <SimpleButton editor={editor} buttonType={SimpleButtonsEnum.BOLD} />
            <SimpleButton editor={editor} buttonType={SimpleButtonsEnum.ITALIC} />
            <SimpleButton editor={editor} buttonType={SimpleButtonsEnum.UNDERLINE} />
            <SimpleButton editor={editor} buttonType={SimpleButtonsEnum.STRIKE} />
            <ListButton editor={editor} />
            <SimpleButton editor={editor} buttonType={SimpleButtonsEnum.BLOCKQUOTE} />
            <LinkButton editor={editor} />
          </StyledFirstRowDiv>
          <StyledBorderDiv />
        </>
      )}
      <StyledSecondRowDiv>
        <ToggleFormattingButton onClick={toggleTopRowVisibility} />
        <ImageButton editor={editor} />
      </StyledSecondRowDiv>
    </StyledWrapperDiv>
  );
};
